import httpClient from 'modules/comments/api/http-client'

interface WorkspaceInterface {
  currentWorkspaceMembership: number | null
}

export const WORKSPACE_API = '/api/settings/workspace'
export const setWorkspace = (data: WorkspaceInterface) => httpClient.post(WORKSPACE_API, data)
